import React from 'react';
import { Container, Typography, Paper, Stack, Divider, Chip, Box } from '@mui/material';
import roadmap from '../data/roadmap.json';

function StatusTag({ status }) {
  const colorMap = {
    planned: 'default',
    'in-progress': 'warning',
    complete: 'success',
  };
  const labelMap = {
    planned: 'Planned',
    'in-progress': 'In Progress',
    complete: 'Complete',
  };
  return <Chip size="small" label={labelMap[status] || status} color={colorMap[status] || 'default'} />;
}

export default function RoadmapPage() {
  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 6 }}>
      <Paper
        variant="outlined"
        sx={{
          p: 4,
          borderRadius: 3,
          background: 'var(--card)',
          borderColor: 'var(--border)',
          boxShadow: 'var(--glow)',
          color: 'var(--text)',
        }}
      >
        <Stack spacing={1.5} alignItems="center" sx={{ textAlign: 'center' }}>
          <Typography variant="h4" component="h1">
            🗺️ Roadmap
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Details (high-density summary). Edit `src/data/roadmap.json` to update without code changes.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Structure uses quarterly blocks beginning at Q4-2025 and continues forward. Each item tracks label, status, description,
            and ETA.
          </Typography>
        </Stack>

        <Stack spacing={3} sx={{ mt: 3 }}>
          {roadmap.quarters.map((quarter) => (
            <Paper
              key={quarter.id}
              variant="outlined"
              sx={{
                p: 3,
                borderRadius: 2,
                background: 'var(--card)',
                borderColor: 'var(--border)',
                boxShadow: 'var(--glow)',
                textAlign: 'center',
              }}
            >
              <Stack direction="column" alignItems="center" spacing={0.5}>
                <Typography variant="h6">{quarter.title}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {quarter.id}
                </Typography>
              </Stack>

              <Divider sx={{ my: 2 }} />

              <Stack spacing={1.5} alignItems="stretch">
                {quarter.items && quarter.items.length > 0 ? (
                  quarter.items.map((item) => (
                    <Box
                      key={item.id}
                      sx={{
                        p: 2,
                        borderRadius: 1.5,
                        border: '1px solid',
                        borderColor: 'divider',
                        backgroundColor: (theme) => theme.palette.background.paper,
                        textAlign: { xs: 'center', sm: 'left' },
                        width: '100%',
                      }}
                    >
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        justifyContent="space-between"
                        alignItems={{ xs: 'center', sm: 'center' }}
                        spacing={1}
                      >
                        <Stack spacing={0.5} sx={{ width: '100%' }} alignItems={{ xs: 'center', sm: 'flex-start' }}>
                          <Typography variant="subtitle1">{item.label}</Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                            {item.description || 'No description provided.'}
                          </Typography>
                        </Stack>
                        <StatusTag status={item.status} />
                      </Stack>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: 'block', mt: 1, textAlign: { xs: 'center', sm: 'left' } }}
                      >
                        ETA: {item.eta || 'TBD'}
                      </Typography>
                    </Box>
                  ))
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    No items yet for this quarter.
                  </Typography>
                )}
              </Stack>
            </Paper>
          ))}
        </Stack>
      </Paper>
    </Container>
  );
}

